<template>
  <section class="container">
    <div class="columns">
      <div class="column is-8">
        <h1>Users</h1>
        <template>
            <v-card>
<v-card-title>
      All Registered Users
      <v-spacer></v-spacer>
      <v-text-field
        append-icon="search"
        label="Search"
        single-line
        hide-details
        v-model="search"
      ></v-text-field>
    </v-card-title>
  <v-data-table
    v-model="selected"
    :headers="headers"
    :items="items"
    :search="search"
    :loading="loading"
    item-key="name"
    select-all
    :pagination.sync="pagination"
  >
      <template slot="headers" slot-scope="props">
      <tr>
        <th
          v-for="header in props.headers"
          :key="header.text"
          :class="['column sortable', pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'active' : '']"
          @click="changeSort(header.value)"
        >
          <v-icon small>arrow_upward</v-icon>
          {{ header.text }}
        </th>
      </tr>
    </template>
  <v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>
    <template slot="items" slot-scope="props">
      <tr :active="props.selected" @click="props.selected = !props.selected">
        <td class="text-xs-left">{{ props.item.firstName }} {{ props.item.lastName }}</td>
        <td class="text-xs-left">{{ props.item.email }}</td>
        <td class="text-xs-left">{{ props.item.telephone }}</td>
        <td class="text-xs-left">{{ props.item.postcode }}</td>
        <td class="text-xs-left">
        <v-btn ripple icon v-if="!props.item.approved" class="mx-0" @click.stop="approveUser(props.item, props.item.approved)"><v-icon color="pink">block</v-icon></v-btn>
        <v-btn ripple icon v-if="props.item.approved" class="mx-0" @click.stop="approveUser(props.item, props.item.approved)"><v-icon color="teal">block</v-icon></v-btn>
       <!--<v-btn icon class="mx-0" @click="deleteUser(props.item)">
          <v-icon color="pink">delete</v-icon>
        </v-btn>-->
        </td>
      </tr>
    </template>
  </v-data-table>
  </v-card>
</template>
      </div>
    </div>
  </section>

</template>

<script>

import shared from '../mixins/shared'

export default {
  name: 'users',
  mixin: [shared],
  data () {
    return {
      search: '',
      items: [],
      loading: true,
      pagination: {
        sortBy: 'name'
      },
      selected: [],
      headers: [
        {
          text: 'Name',
          align: 'left',
          value: 'lastName'
        },
        { text: 'Email', value: 'email', sortable: true },
        { text: 'Telephone', value: 'telephone', sortable: true },
        { text: 'Post Code', value: 'postcode', sortable: true },
        { text: 'Actions', value: 'name', sortable: false }
      ]
    }
  },
  methods: {
    loadUsers () {
      this.$binding('items', this.$db.collection('userMeta'))
        .then((items) => {
          this.loading = false
        }).catch(error => {
          console.error(error)
        })
    },
    deleteUser (item) {
      const index = this.items.indexOf(item)
      confirm('Are you sure you want to delete this user?') && this.items.splice(index, 1)
      this.$db.collection('userMeta').doc(item['.key']).delete()
        .then(() => {
          this.addNotification({text: 'Document successfully deleted!', color: 'success'})
          this.loading = false
        })
        .catch((error) => {
          this.addNotification({text: 'Error deleting user', color: 'error'})
          console.error(error)
        })
    },
    approveUser (item, isApproved) {
      isApproved = !isApproved
      this.$db.collection('userMeta').doc(item['.key']).update({
        approved: isApproved
      }).catch((error) => {
        this.addNotification({text: 'Error editing user', color: 'error'})
        console.error(error)
      })
    },
    toggleAll () {
      if (this.selected.length) this.selected = []
      else this.selected = this.items.slice()
    },
    changeSort (column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending
      } else {
        this.pagination.sortBy = column
        this.pagination.descending = false
      }
    }
  },
  mounted () {
    this.loadUsers()
  }
}
</script>

<style lang="scss" scoped>
table thead th {
  text-align:  left;
}
  h1 {
    font-size: 28px;
    margin: 30px 0;
  }

</style>



// WEBPACK FOOTER //
// UserList.vue?a1875982